import { API } from 'config';

function CatalogService($http) {

  'ngInject';

  return {

    getReportSchema: (version) => $http.get(`${API.BASE_CATALOG}/report_schema_${version}.json`),

  };
}

export default CatalogService;



// WEBPACK FOOTER //
// ./src/services/Catalog.js